import React from "react";

const PaymentDetailFlight = ({ activeStep, setActiveStep }) => {
  return <div>PaymentDetailFlight</div>;
};

export default PaymentDetailFlight;
